module.exports = '4.14.0';



// WEBPACK FOOTER //
// ./src/version.js